import {
  Mesh,
  Material,
  MeshBasicMaterial,
  CylinderBufferGeometry,
  Vector3,
  WebGLRenderer,
  Scene,
  Camera,
  BufferGeometry,
  OrthographicCamera,
  LineBasicMaterial,
  LineLoop,
  Line,
  LineDashedMaterial
} from "three";
import { Quick3DPerspectiveCamera } from "../camera/quick3d-perspective-camera";
import * as Config from "../config/ViewerConfig";

export class ExtendedLineDashed extends Line {
  private _points: Vector3[];
  private _defaultMaterial: Material;
  private _selectedMaterial: Material;

  get points() {
    return this._points;
  }
  constructor(
    material: Material = new MeshBasicMaterial({ color: 0x0000ff })
  ) {
    const geometry = new BufferGeometry();
    super(geometry, material);

    this._defaultMaterial = material;
    this._selectedMaterial = new LineDashedMaterial({
      color: Config.SELECTED_MEASUREMENT_COLOR,
      dashSize: 0.2,
      gapSize: 0.1,
      depthTest: false,
      transparent: true
    });
  }

  public prepareRendering(points: Vector3, pointOfIntersection: Vector3) {
    this.geometry.setFromPoints([
      points,
      pointOfIntersection,
    ]);
  }

  public setSelectedMaterial(isSelected: boolean) {
    this.material = isSelected ? this._selectedMaterial : this._defaultMaterial;
  }

  public changeRenderOrderBySelected(isSelected: boolean) {
    this.renderOrder = isSelected ? 2 : 0;
  }
}
